import ListOut from '@components/shared/ListOut'

const FormLinksCustom = ({ show = true, links, LinkItem, ...rest }) => {
    if (!show) return null
    return <ListOut id="t" items={links} Component={LinkItem} {...rest} />
}

export default FormLinksCustom